import { getAreamoduleDetail } from "api/mall"
import { useEffect, useState } from "react"

type AreaTemplateTableProps = {
  data: Array<any>
  sysNo: string
}

export default function AreaTemplateTable({
  data = [],
  sysNo = "",
}: AreaTemplateTableProps) {
  const [detail, setDetail] = useState({} as any)

  const fetchDetail = async () => {
    const res = await getAreamoduleDetail(sysNo)
    setDetail(res.data)
  }

  useEffect(() => {
    fetchDetail()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sysNo])

  return (
    <div>
      <table className="table">
        <thead className="header">
          <tr>
            <th rowSpan={2}>类别</th>
            <th rowSpan={2}>单价计价公式类型</th>
            <th rowSpan={2}>比例系数</th>
            <th colSpan={detail?.regionList?.length}>地区差值</th>
          </tr>
          <tr>
            {detail?.regionList?.map((item) => (
              <th key={item.sysNo}>{item.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((item) => (
            <tr key={item.materialCategorySysNo} className="row">
              <td>{item.categoryName}</td>
              <td>{item.formula}</td>
              <td>{item.paramList[0] ? `${item.paramList[0]}%` : "--"}</td>
              {item?.templateAreaDiscountList?.map((item) => (
                <td key={item.templateAreaSysNo}>{item.discount}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <style jsx>{`
        .table {
          min-width: 800px;
          border-color: #eee;
        }
        .header {
          height: 72px;
          background: #f6f6f6;
          border: 1px solid #eeeeee;
          text-align: left;
        }
        .table th {
          padding-left: 5px;
        }
        .table td {
          padding-left: 5px;
        }
        .row {
          height: 38px;
          border-bottom: 1px solid #e5e5e5;
        }
      `}</style>
    </div>
  )
}
